// InvoicePrintView.js
import React, { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
import './invoice-print.css';

const InvoicePrintView = ({ invoiceData, onClose, showPrint }) => {
  const printRef = useRef();
  const barcodeRef = useRef(null);
  const [organizationName, setOrganizationName] = useState('');

  useEffect(() => {
    const orgData = localStorage.getItem('userSettings');
    if (orgData) {
      try {
        const parsed = JSON.parse(orgData);
        if (parsed.organization_name) setOrganizationName(parsed.organization_name);
      } catch (e) {
        console.error('Error parsing User details from localStorage:', e);
      }
    }

    // generate barcode whenever invoiceData changes
    if (invoiceData && barcodeRef.current) {
      const raw = String(invoiceData.invoice_number || invoiceData.id || '');
      const value = raw.startsWith('INV-') ? raw : `INV-${raw}`;

      try {
        // JsBarcode can accept an SVG DOM element
        JsBarcode(barcodeRef.current, value, {
          format: 'CODE128',      // compact and good for alphanumeric invoice ids
          displayValue: true,     // show the text under barcode (prints too)
          fontSize: 10,
          height: 36,
          margin: 0,
          textMargin: 2,
        });
      } catch (err) {
        console.error('Barcode generation failed', err);
      }
    }

    if (showPrint) {
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          window.print();
          onClose();
        });
      }, 500);   // More stable for thermal printing
    }
  }, [invoiceData, showPrint, onClose]);

  const formatCurrency = (val) => `${parseFloat(val || 0).toFixed(2)}`;

  // use invoiceData.invoice_number; ensure fallback if not present
  const invoiceNumber = invoiceData ? (invoiceData.invoice_number || `INV-${invoiceData.id || ''}`) : '';

  return (
    <div className="print-area" ref={printRef}>
      <div className="org-text">{organizationName}</div>

      <div className="left-text">Invoice #{invoiceNumber}</div>
      <div className="left-text">Date: {(new Date(invoiceData?.date)).toLocaleString()}</div>
      <div className="left-text">Payment Mode: {invoiceData?.pay_cash ? 'Cash' : 'Card Payment'}</div>
      <div>Customer: {invoiceData?.invoiced_customer || 'Walk-in Customer'}</div>

      <div className="line" />

      <table className="items-table">
        <thead>
          <tr>
            <th className="left">Item</th>
            <th className="right">Qty</th>
            <th className="right">Price</th>
            <th className="right">Total</th>
          </tr>
        </thead>
        <tbody>
          {invoiceData?.items?.map((item) => (
            <React.Fragment key={item.id}>
              <tr>
                <td className="left" colSpan={4}>{item.product?.name}</td>
              </tr>
              <tr>
                <td></td>
                <td className="right">{item.quantity}</td>
                <td className="right">{formatCurrency(item.price)}</td>
                <td className="right">{formatCurrency(item.total)}</td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div className="line" />
      <table className="items-table">
        <tbody>
          <tr className="total-row"><td><strong>Sub Total:</strong></td><td>{formatCurrency(invoiceData?.total_price)}</td></tr>
          <tr className="total-row"><td><strong>Discount:</strong></td><td>{invoiceData?.isdiscount_per ? (invoiceData.total_price * (invoiceData.discount||0)/100).toFixed(2) : formatCurrency(invoiceData?.discount || 0)}</td></tr>
          <tr className="total-row"><td><strong>Net Total:</strong></td><td>{formatCurrency(invoiceData?.net_price)}</td></tr>
        </tbody>
      </table>

      <div className="line" />

      {/* Barcode area */}
      <div className="barcode-wrapper center-text" aria-hidden="true">
        {/* SVG element that JsBarcode will write into */}
        <svg ref={barcodeRef} />
      </div>

      <div className="line" />
      <div className="center-text">Thank you for your visit!</div>
    </div>
  );
};

export default InvoicePrintView;
